<template>
  <router-link :to=destination class="btn btn-secondary btn-lg btn-block">
    <div class="d-flex justify-content-between align-items-center">
      <span class="text-white">{{ label }}</span>
      <img src="../assets/ButtonArrow.svg" height="25" alt="arrow button">
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ArrowButton',
  props: [
    'label',
    'destination',
  ],
};
</script>
